// Library of starter page templates. Each returns { title, content (HTML) }.
// The HTML matches what TipTap renders so the editor opens with a useful skeleton.

export const PAGE_TEMPLATES = [
  {
    id: 'blank',
    title: 'Blank page',
    description: 'Start from scratch',
    icon: '📄',
    build: () => ({ title: 'Untitled', content: '' }),
  },
  {
    id: 'meeting_notes',
    title: 'Meeting notes',
    description: 'Agenda · Notes · Action items',
    icon: '📝',
    build: () => ({
      title: 'Meeting notes — ' + new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }),
      content: `
        <p><strong>Date:</strong> ${new Date().toLocaleDateString()}<br>
        <strong>Attendees:</strong> </p>
        <h2>Agenda</h2>
        <ul><li>Item 1</li><li>Item 2</li></ul>
        <h2>Discussion notes</h2>
        <p></p>
        <h2>Decisions</h2>
        <ul><li></li></ul>
        <h2>Action items</h2>
        <ul><li>[ ] Owner — task — due date</li></ul>
      `.trim(),
    }),
  },
  {
    id: 'prd',
    title: 'Product requirements (PRD)',
    description: 'Problem · Goals · Solution · Risks',
    icon: '📐',
    build: () => ({
      title: 'PRD — ',
      content: `
        <h2>Overview</h2>
        <p><strong>Author:</strong> · <strong>Status:</strong> Draft · <strong>Last updated:</strong> ${new Date().toLocaleDateString()}</p>
        <h2>Problem</h2>
        <p>What user / business problem are we solving and for whom?</p>
        <h2>Goals & success metrics</h2>
        <ul><li>Goal: …</li><li>Metric: …</li></ul>
        <h2>Non-goals</h2>
        <ul><li></li></ul>
        <h2>Proposed solution</h2>
        <p></p>
        <h2>UX / flows</h2>
        <p>Add screenshots or links here.</p>
        <h2>Open questions</h2>
        <ul><li></li></ul>
        <h2>Risks & mitigations</h2>
        <ul><li></li></ul>
      `.trim(),
    }),
  },
  {
    id: 'rfc',
    title: 'Engineering RFC',
    description: 'Tech design · Tradeoffs · Rollout',
    icon: '⚙️',
    build: () => ({
      title: 'RFC — ',
      content: `
        <h2>Summary</h2>
        <p>One-paragraph TL;DR of the proposal.</p>
        <h2>Background</h2>
        <p>Why this RFC exists.</p>
        <h2>Proposal</h2>
        <p></p>
        <h2>Alternatives considered</h2>
        <ul><li><strong>Option A:</strong> …</li><li><strong>Option B:</strong> …</li></ul>
        <h2>Tradeoffs</h2>
        <ul><li>Pros: …</li><li>Cons: …</li></ul>
        <h2>Rollout plan</h2>
        <ol><li>Phase 1 …</li><li>Phase 2 …</li></ol>
        <h2>Telemetry & success metrics</h2>
        <ul><li></li></ul>
      `.trim(),
    }),
  },
  {
    id: 'retro',
    title: 'Sprint retrospective',
    description: 'Went well · Didn\u2019t go well · Actions',
    icon: '🪞',
    build: () => ({
      title: 'Retro — Sprint ',
      content: `
        <h2>What went well</h2>
        <ul><li></li></ul>
        <h2>What didn't go well</h2>
        <ul><li></li></ul>
        <h2>What did we learn</h2>
        <ul><li></li></ul>
        <h2>Action items for next sprint</h2>
        <ul><li>[ ] Owner — task — due</li></ul>
      `.trim(),
    }),
  },
  {
    id: 'onboarding',
    title: 'Onboarding guide',
    description: 'Getting started · Contacts · Resources',
    icon: '🚀',
    build: () => ({
      title: 'Onboarding guide',
      content: `
        <h2>Welcome 👋</h2>
        <p>What this project is about — and what you'll be working on.</p>
        <h2>Getting started checklist</h2>
        <ul><li>[ ] Read the project README</li><li>[ ] Set up local env</li><li>[ ] Pair with </li></ul>
        <h2>Key people</h2>
        <ul><li><strong>Project lead:</strong> </li><li><strong>Tech lead:</strong> </li><li><strong>Designer:</strong> </li></ul>
        <h2>Resources</h2>
        <ul><li>Repo: </li><li>Figma: </li><li>Slack: </li></ul>
      `.trim(),
    }),
  },
  {
    id: 'decision_log',
    title: 'Decision log',
    description: 'Capture key decisions over time',
    icon: '🧭',
    build: () => ({
      title: 'Decision log',
      content: `
        <h2>Decision log</h2>
        <p>Use this page to record significant decisions and their context.</p>
        <h3>${new Date().toLocaleDateString()} — Decision title</h3>
        <p><strong>Context:</strong> </p>
        <p><strong>Decision:</strong> </p>
        <p><strong>Owner:</strong> </p>
        <hr>
      `.trim(),
    }),
  },
];

export function getTemplate(id) {
  return PAGE_TEMPLATES.find(t => t.id === id) || PAGE_TEMPLATES[0];
}
